<script>
	import {
		Modal,
		ModalBody,
		ModalFooter,
		ModalHeader,
	} from "@sveltestrap/sveltestrap";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";

	export let isOpen = false;
	export let toggle = () => {};
</script>

<Modal {isOpen} {toggle} centered>
	<ModalHeader {toggle}>Unable to add to same work order</ModalHeader>
	<ModalBody>
		<p class="mixed-kind-warning-text">
			Non-workshop issues cannot be added to the same work order as with
			Bodywork and Maintenance issues.
		</p>
	</ModalBody>
	<ModalFooter>
		<CustomButton
			buttonText="Back to issues"
			color="custom-blue"
			on:click={toggle}
		/>
	</ModalFooter>
</Modal>

<style>
	.mixed-kind-warning-text {
		margin: 0;
	}
</style>
